import React from 'react';
import { Stack, Slider, Typography, Box, Divider } from '@mui/joy';
import { LibraryAdd as ExternalLayersIcon } from '@mui/icons-material';
import { ExternalLayers } from './external-layers';
import { useSettings } from "@context";

export const icon = <ExternalLayersIcon />;
export const title = 'External Data Layers';

/**
 * render the model selection component
 *
 * @returns React.ReactElement
 */
export const trayContents = () => {
    // get the layer opacity setting state
    const {
        layerOpacity,
        setChangesMade
    } = useSettings();

    const handleOnChange = (e) => {
        setChangesMade(true);
        layerOpacity['external'].set(e.target.value);
    };

    return (
        <Stack direction="column" gap={0} p={2}>
            <Box width={ 300 }>
                <Typography level="title-md">External Layer Opacity</Typography>
                <Slider
                    aria-label="opacity slider"
                    value={layerOpacity['external'].current}
                    step={0.01}
                    min={0.01}
                    max={1.0}
                    valueLabelDisplay="auto"
                    sx={{mr: '10px'}}
                    onChange={ handleOnChange }
                />
                <Divider/>
            </Box>
            <ExternalLayers/>
        </Stack>

    );
};